import { Preloader } from "MWComponents";
import SliderComponent from "../../../auxiliary-components/shared/Slider";
import TabsNew from "../../../auxiliary-components/shared/TabsNew";
import InstallmentFromStatementNew from "../views/installment_from_statement-new.c";
import PayByPartsNewNew from "../views/payByParts-new-new.c";
import QuestionsAdminBlock from "../../../auxiliary-components/shared/QuestionsAdmin";
import React from "react";
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';

export default function template() {
    const isMobile = this.isViewportMobile();
    const modes = [ {mode: 'pay-by-parts', title: 'PBP_ENTITY_TAB_1'},
      {mode: 'installment', title: 'PBP_ENTITY_TAB_2'},
      {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}];

    let page;
    page = 'pbp';
    let pageInstallment;
    if (this.state.mode === 'installment') {
      pageInstallment = 'installment'
    }

    return (
      <div className={page}>
        <div className='slider-container'>
            {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
        </div>
        <TabsNew modes={modes} isMobile={isMobile} page={page} toggle={this.toggleMode} mode={this.state.mode}>
            <div className="wrapper" type={modes[0].mode}>
              <PayByPartsNewNew/>
            </div>
            <div className="wrapper" type={modes[1].mode}>
              <InstallmentFromStatementNew page={pageInstallment} tab={modes[1].mode}/>
            </div>
            <div className='wrapper' type={modes[2].mode}>
                <div className='content'>
                    <QuestionsAdminBlock page={page} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
                    <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>
                </div>
            </div>
        </TabsNew>
      </div>
    )
}